<template>
  <div class="main-button" :style="{ width: width }" :class="variantButton">
    <button
      :style="{
        height: customHeight ? customHeight : height,
        backgroundColor: backgroundColor,
        fontSize: customFontSize ? customFontSize : fontSize,
        borderRadius: borderRadius ? borderRadius : rounded ? '10px' : '0px',
        maxWidth: maxWidth,
        color: textColor,
        fontWeight: fontWeight,
      }"
      :type="type"
      :form="form"
      :disabled="disabled"
      @click="handleClick"
    >
      <slot></slot>
      {{ btnText }}
    </button>
  </div>
</template>
<script>
export default {
  name: "MainButton",
  props: {
    btnText: String,
    size: String, // 'small'|'medium'|'large' | x-large
    variant: String, // outlined | contained | text
    color: String, // 'primary'|'secondary'|'green'|'yellow'|'blue'|'lightRed'|'lightGreen' | 'red2'
    rounded: Boolean, //
    maxWidth: String, //
    width: String,
    type: {
      type: String,
      default: "button",
    },
    customHeight: String, //
    borderRadius: String,
    fontWeight: {}, //
    customFontSize: String,
    form: String,
    to: String,
    target: {
      type: String,
      default: "_self",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      height: "40px",
      backgroundColor: "#26336A",
      fontSize: "2.4rem",
      textColor: "#fff",
      variantButton: "contained",
    };
  },

  mounted() {
    this.updateStyle();
  },

  updated() {
    this.updateStyle();
  },

  methods: {
    updateStyle() {
      if (this.size == "small") {
        this.height = "36px";
        this.fontSize = "16px";
      } else if (this.size == "medium") {
        this.height = "40px";
        this.fontSize = "2.4rem";
      } else if (this.size == "large") {
        this.height = "48px";
        this.fontSize = "2.1rem";
      } else if (this.size == "x-large") {
        this.height = "54px";
        this.fontSize = "2.1rem";
      }

      if (this.color == "grayLightest") {
        this.backgroundColor = "#FAFAFA";
        this.textColor = "#A6A6A6";
      }

      if (this.variant == "outlined") {
        this.variantButton = "outlined";
      }

      // Color
      switch (this.color) {
        case "primary":
          this.backgroundColor = "#26336A";
          break;
        case "secondary":
          this.backgroundColor = "#9E1915";
          break;
        case "green":
          this.backgroundColor = "#599C60";
          break;
        case "blue":
          this.backgroundColor = "#70CED4";
          break;
        case "lightRed":
          this.backgroundColor = "#FF7878";
          break;
        case "red":
          this.backgroundColor = "#9E1915";
          break;
        case "red2":
          this.backgroundColor = "#E22F2F";
          break;
        case "lightGreen":
          this.backgroundColor = "#B1DF8D";
          break;
        case "gray":
          this.backgroundColor = "#989898";
          break;
        case "grayLightest":
          this.backgroundColor = "#FAFAFA";
          this.textColor = "#A6A6A6";
          break;

        default:
          break;
      }
    },
    handleClick() {
      if (this.to) {
        if (this.to.startsWith("/") || !this.to.startsWith("http")) {
          if (this.target == "_self") this.$router.push(this.to);
          else {
            const routeData = this.$router.resolve({ name: this.to });
            window.open(routeData.href, this.target);
          }
        } else if (this.to.startsWith(location.origin)) {
          this.$router.push(this.to.substring(location.origin.length));
        } else {
          window.open(this.to, "_blank");
        }
        return;
      }
      this.$emit("click");
    },
  },
};
</script>

<style scoped lang="scss">
.main-button {
  flex-shrink: 0;

  button {
    padding-left: 12px;
    padding-right: 12px;
    border: 0px !important;
    cursor: pointer;
    color: #fff;
    width: 100%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 100%;
    &:disabled {
      opacity: 0.6;
    }
  }
}

.outlined {
  button {
    border: 1px solid #989898 !important;
    background-color: #fff !important;
    color: #5a5a5a !important;
  }
}
</style>
